import defaultMuiTheme from './default';
const { mixins } = { ...defaultMuiTheme };
mixins.toolbar.minHeight = 48;
export default mixins;
//# sourceMappingURL=mixins.js.map